import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface AccountTypeMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAccountTypeMasterList: any[];
}

const initialState: AccountTypeMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allAccountTypeMasterList: [],
};

export const accountTypeMasterSlice = createSlice({
  name: "accountTypeMaster",
  initialState,
  reducers: {
    setAccountTypeMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAccountTypeMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAccountTypeMaster: (state, action) => {
      state.allAccountTypeMasterList = action.payload.data; // no pagination
    },
    reset: () => initialState,
  },
});

export const {
  setAccountTypeMaster,
  setAccountTypeMasterBySearch,
  setAllAccountTypeMaster,
  reset,
} = accountTypeMasterSlice.actions;

export const getAccountTypeMasterDetails = (state: RootState) =>
  state.accountTypeMaster.data;
export const getAccountTypeMasterBySearchDetails = (state: RootState) =>
  state.accountTypeMaster.data;
export const getAccountTypeTotalRecords = (state: RootState) =>
  state.accountTypeMaster.totalRecords;
export const getAccountTypeMasterList = (state: RootState) =>
  state.accountTypeMaster.allAccountTypeMasterList;

export default accountTypeMasterSlice.reducer;
